import { Link, generatePath } from 'react-router-dom';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Text16, Title6 } from '@sorare/core/src/atoms/typography';

import { PlayerAvatar } from '@sorare/us-sports/src/components/player/Avatar';

const Wrapper = styled(Link)`
  display: flex;
  gap: var(--double-unit);
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: var(--unit);
  cursor: pointer;

  &:hover,
  &:focus {
    background-color: var(--c-neutral-300);
  }
`;

const TinyPlayerAvatar = styled(PlayerAvatar).attrs({ cropWidth: 80 })`
  width: calc(6 * var(--unit));
  background: var(--c-neutral-300);
  border-radius: var(--unit);
  box-shadow: 0 var(--half-unit) calc(3 * var(--unit)) rgba(0, 0, 0, 0.2);
`;

const NamesWrapper = styled(Vertical).attrs({ gap: 0 })`
  gap: 3px;
  text-align: left;
  margin-right: auto;
`;

type Props = {
  route: string;
  playerSlug: string;
  playerName: string;
  playerPicture: string;
  teamName: string;
};

export const PlayerRow = ({
  route,
  playerSlug,
  playerName,
  playerPicture,
  teamName,
}: Props) => {
  return (
    <Wrapper to={generatePath(route, { slug: playerSlug })}>
      <TinyPlayerAvatar
        player={{ displayName: playerName, avatarPictureUrl: playerPicture }}
      />
      <NamesWrapper>
        <Title6>{playerName}</Title6>
        <Text16 color="var(--c-neutral-600)">{teamName}</Text16>
      </NamesWrapper>
    </Wrapper>
  );
};
